(function ($) {
  $(document).ready(function ($) {
    /**********************************************************************
      Table of Contents:
        1. Opening and closing of the cart globally
        2. Handing of the quantity box clicks & changes
        3. Adding to Cart
        4. Removing from Cart
        5. Updating Cart Quantity
        6. Re-generating the AJAX cart items when cart is changed
        7. Shopify function for handling money formatting
    ***********************************************************************/

    /**********************************************************************
     1.
      Opening & closing the cart
    ***********************************************************************/
    function openCart() {
      $("body").addClass("cart-open");
      $("body").addClass("noscroll");
      $("#cart-popper").attr("aria-expanded", "true");
      $("#cart-pop").attr("aria-hidden", "false");

      // Store the element that had focus before opening the cart
      window._lastFocusedElement = document.activeElement;

      // Focus the close button
      $("#close-cart-popper").focus();
    }

    function closeCart() {
      $("body").removeClass("cart-open");
      $("body").removeClass("noscroll");
      $("#cart-popper").attr("aria-expanded", "false");
      $("#cart-pop").attr("aria-hidden", "true");

      // Return focus to the element that had focus before opening the cart
      if (window._lastFocusedElement) {
        window._lastFocusedElement.focus();
      }
    }

    $("#cart-popper").click(function (event) {
      openCart();
    });

    $("#close-cart-popper").click(function (event) {
      closeCart();
    });

    // Handle escape key to close cart
    $(document).on("keydown", function (e) {
      if (e.key === "Escape" && $("body").hasClass("cart-open")) {
        closeCart();
      }
    });

    $("#MainContent").click(function (event) {
      if ($("body").hasClass("cart-open")) {
        closeCart();
      }
    });

    // if this is the cart page, on page load we want the openCart function called
    if ($("body.cart").length) {
      openCart();
    }
    /**********************************************************************
      END –
      Opening & closing the cart
    ***********************************************************************/

    /**********************************************************************
     2. 
      Quantity Buttons handling
    ***********************************************************************/
    $(".quantity-box .minus").click(function (event) {
      var $el = $(this);
      quantityMinusHandler(event, $el);
    });

    $(".quantity-box .plus").click(function (event) {
      var $el = $(this);
      quantityPlusHandler(event, $el);
    });

    function quantityMinusHandler(event, element) {
      event.preventDefault();

      var input = $(element).siblings(".quantity-input-wrap").children("input"),
        count = $(input).val();

      if (count == 1) {
        // do nothing, can't have negative quantity
      } else if (count == 2) {
        count--;
        $(element).addClass("disabled");
        $(input).val(count);
      } else {
        count--;
        $(input).val(count);
      }
    }

    function quantityPlusHandler(event, element) {
      event.preventDefault();

      var input = $(element).siblings(".quantity-input-wrap").children("input"),
        minus = $(element).siblings(".minus"),
        count = $(input).val();

      $(minus).removeClass("disabled");
      count++;
      $(input).val(count);
    }

    /**********************************************************************
      END –
      Quantity Buttons handling
    ***********************************************************************/

    /**********************************************************************
     3. 
      Adding to the AJAX Cart from product pages
        – Will probably need to be refactored a bit if we need to put 
          add to cart on none product pages
    ***********************************************************************/
    var AjaxAddToCart = (function () {
      var $ATC = $(".atc-btn");

      if (!$ATC.length) {
        return;
      }

      $(document).on("click", ".atc-btn", function (e) {
        e.preventDefault();
        var $form = $(e.currentTarget.form);
        var $variantSelect = $form.find('select[name="id"]');
        var $variantInput = $form.find('input[name="id"]');
        var $quantityInput = $form.find('input[name="quantity"]');

        // Try to get variant ID from form first
        var variantId = $variantSelect.val() || $variantInput.val();

        // If no variant ID found in form, try to get it from the product data
        if (!variantId) {
          try {
            var productData = JSON.parse($form.find(".product-form__data").text());
            var $groups = $form.find(".product-form__group");
            var options = [];

            // console.log("Product data found:", productData);
            // console.log("Product groups found:", $groups.length);

            // Get selected options from radio buttons
            $groups.each(function () {
              var $this = $(this);
              var val = $this.find(".product-form__group__select select").val();
              options.push(val);
              // console.log("Option value:", val);
            });

            // console.log("All options:", options);

            // Find matching variant
            $.each(productData.variants, function (i, variant) {
              // console.log("Checking variant:", variant.option1, variant.option2, variant.option3);
              if (variant.option1 == options[0] && variant.option2 == options[1] && variant.option3 == options[2]) {
                variantId = variant.id;
                // console.log("Found matching variant:", variantId);
                return false;
              }
            });
          } catch (e) {
            console.log("Error parsing product data:", e);
          }
        }

        var quantity = $quantityInput.val() || 1;

        // Final fallback: try to get variant ID from the product data directly
        if (!variantId && productData) {
          // console.log("Trying final fallback - using first available variant");
          variantId = productData.variants[0].id;
        }

        // Debug form elements
        // console.log("Form found:", $form.length > 0);
        // console.log("Variant select found:", $variantSelect.length > 0);
        // console.log("Variant input found:", $variantInput.length > 0);
        // console.log("Quantity input found:", $quantityInput.length > 0);
        // console.log("Variant select value:", $variantSelect.val());
        // console.log("Variant input value:", $variantInput.val());
        // console.log("Quantity input value:", $quantityInput.val());

        // Debug bundle-specific elements
        // console.log("Checked radio buttons:", $form.find('input[type="radio"]:checked').length);
        // console.log("All radio buttons:", $form.find('input[type="radio"]').length);
        // $form.find('input[type="radio"]:checked').each(function () {
        //   console.log("Checked radio:", $(this).val(), $(this).attr("name"));
        // });

        // Create the new format data
        var cartData = {
          items: [
            {
              id: parseInt(variantId),
              quantity: parseInt(quantity),
            },
          ],
        };

        // Debug: Log the data being sent
        // console.log("Cart data being sent:", cartData);
        // console.log("Variant ID:", variantId);
        // console.log("Quantity:", quantity);

        $form.addClass("loading");

        $.ajax({
          url: "/cart/add.js",
          type: "POST",
          dataType: "json",
          contentType: "application/json",
          data: JSON.stringify(cartData),
          complete: function (jqXHR, response) {
            // console.log("Response status:", jqXHR.status);
            // console.log("Response text:", jqXHR.responseText);
            // console.log("Response headers:", jqXHR.getAllResponseHeaders());

            if (jqXHR.status == 200) {
              // Fetch cart data for Klaviyo tracking
              fetch(`${window.location.origin}/cart.js`)
                .then((res) => res.json())
                .then((data) => {
                  var cart = {
                    total_price: data.total_price / 100,
                    $value: data.total_price / 100,
                    total_discount: data.total_discount,
                    original_total_price: data.original_total_price / 100,
                    PriceNumber: data.total_price / 100,
                    items: data.items,
                  };

                  //console.log(cart);
                  _learnq.push(["track", "Added to Cart", cart]);
                })
                .catch((error) => {
                  console.log("Fetch error:", error);
                });

              // Product added to cart successfully
              CartPopup.update(function () {
                CartPopup.open();
                $("html, body").animate({ scrollTop: 0 }, "slow");
                $("#cart-pop").scrollTop(0);
                $(e.currentTarget.form).removeClass("loading");
              });
            } else {
              // Handle failure cases
              // ... (your existing code)
            }
          },
        });
      });
    })();

    /**********************************************************************
      END –
      Adding to the AJAX Cart from product pages
    ***********************************************************************/

    /**********************************************************************
     4. 
      Removing an item from the AJAX Cart
    ***********************************************************************/
    var AjaxRemoveFromCart = (function () {
      $(document).on("click", ".remove-from-cart", function (e) {
        e.preventDefault();
        e.stopPropagation();

        $("#cart-pop").find(".cart-items").addClass("loading");
        var productId = $(this).attr("data-variant");
        var cartData = { updates: { [productId]: 0 } };

        $.ajax({
          type: "POST",
          url: "/cart/update.js",
          dataType: "json",
          data: cartData,
          complete: function (jqXHR, response) {
            if (jqXHR.status == 200) {
              //product added to cart successfully
              CartPopup.update(function () {
                CartPopup.open();
                $("html, body").animate({ scrollTop: 0 }, "slow");
                $("#cart-pop").scrollTop(0);
                $(e.currentTarget.form).removeClass("loading");
                $("#cart-pop").find(".cart-items").removeClass("loading");
              });
            } else {
              //failed to add to cart for x reason
              var resText = jqXHR.responseText;
              if (resText.indexOf("You can't add more") > -1) {
                console.log(
                  "You attempted to add more of this item than we have in stock, please select a lower quantity and try again."
                );
              } else if (resText.indexOf("are in your bag") > -1) {
                console.log("The remaining inventory of this product option is already in your bag.");
              } else {
                console.log("Something went wrong trying to add to bag " + response);
              }
              $("html, body").animate({ scrollTop: 0 }, "slow");
              $("#cart-pop").scrollTop(0);
              $(e.currentTarget.form).removeClass("loading");
            }
          },
        });
      });
    })();
    /**********************************************************************
      END –
      Removing an item from the AJAX Cart
    ***********************************************************************/

    /**********************************************************************
      5. 
        Updating Cart Quantity
    ***********************************************************************/
    $(document).on("click", ".quantity-box-cart .minus", function (event) {
      var $el = $(this);
      quantityCartMinusHandler(event, $el);
      $("#cart-pop").find(".cart-items").addClass("loading");
    });

    $(document).on("click", ".quantity-box-cart .plus", function (event) {
      var $el = $(this);
      quantityCartPlusHandler(event, $el);
      $("#cart-pop").find(".cart-items").addClass("loading");
    });

    function quantityCartMinusHandler(event, element) {
      event.preventDefault();

      var input = $(element).siblings(".quantity-input-wrap").children("input"),
        count = $(input).val();

      if (count == 1) {
        // do nothing, can't have negative quantity
      } else if (count == 2) {
        count--;
        $(element).addClass("disabled");
        $(input).val(count);

        updateCartQuantity($(input));
      } else {
        count--;
        $(input).val(count);

        updateCartQuantity($(input));
      }
    }

    function quantityCartPlusHandler(event, element) {
      event.preventDefault();

      var input = $(element).siblings(".quantity-input-wrap").children("input"),
        minus = $(element).siblings(".minus"),
        count = $(input).val();

      $(minus).removeClass("disabled");
      count++;
      $(input).val(count);

      updateCartQuantity($(input));
    }

    function updateCartQuantity(inputElement) {
      var $this = inputElement;
      var quantity = $this.val();

      var $item = $this.closest(".cart-item");
      var id = parseInt($item.data("variant"));
      var item = {};
      item["id"] = id;
      item["quantity"] = quantity;

      $.ajax({
        url: window.Shopify.routes.root + "cart/change.js",
        type: "post",
        data: item,
        success: function (res) {
          //console.log('cart updated');
          CartPopup.update();
          $("#cart-pop").find(".cart-items").removeClass("loading");
        },
        error: function (res) {
          console.log(res);
        },
      });
    }

    /**********************************************************************
     END –
     Updating Cart Quantity
   ***********************************************************************/

    /**********************************************************************
     6. 
      Updates the AJAX cart
        – call this function when you need to re-render what's inside the
          cart via an AJAX call, remove/add/change/etc
    ***********************************************************************/
    var CartPopup = (function () {
      var $cart = $("#cart-pop");

      function updateCart(callback) {
        $.getJSON("/cart.js", function (data) {
          var subtotal = data.total_price;
          var count = data.item_count;
          var html = "";
          var $upsells = $(".addon-card");
          $upsells.removeClass("hide");
          //console.log(count);
          if (count == 0) {
            $("#cart-popper").removeClass("itemsincart");
            html += `<h3 class="h4">Your cart is empty!</h3>`;
          } else {
            $("#cart-popper").addClass("itemsincart");
            $.each(data.items, function (index, item) {
              var $currentUpsell = $upsells.filter('[data-product="' + item.handle + '"]');
              if ($currentUpsell.length) {
                $currentUpsell.addClass("hide");
              }

              var image = item.image ? item.image.split(".") : [];
              var img_ext = image[image.length - 1];
              if (img_ext) {
                var image = item.image.replace("." + img_ext, "_250x250_crop_center." + img_ext);
              }

              // Adding the quantity-box-cart markup here
              var quantityBoxMarkup = `
          <div class="quantity-box-cart">
            <button class="minus quantity-btn ${item.quantity <= 1 ? "disabled" : ""}">
              <span class="visually-hidden">Decrease quantity</span>
              <span class="icon">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100"><g><rect x="4" y="46" width="90" height="8"></rect></g></svg>
              </span>
            </button>
            <div class="quantity-input-wrap">
              <label class="visually-hidden" for="cart-quantity-input-${item.id}">Select how many you want</label>
              <input class="quantity-input" id="cart-quantity-input-${item.id}" type="number" min="1" name="quantity" value="${
                item.quantity
              }">
            </div>
            <button class="plus quantity-btn">
              <span class="visually-hidden">Increase quantity</span>
              <span class="icon">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100"><g><polygon points="95 46 54 46 54 5 46 5 46 46 5 46 5 54 46 54 46 95 54 95 54 54 95 54 95 46"></polygon></g></svg>
              </span>
            </button>
          </div>`;

              var variantTitleMarkup =
                item.variant_title && item.variant_title !== "Default Title"
                  ? `<span class="accent-sub">${item.variant_title}</span>`
                  : "";

              html += `<div class="cart-item" data-variant="${item.id}">
                <div class="cart-item__img">
                  <a class="" href="${item.url}">
                    <img src="${image}" width="250" height="250"/>
                  </a>
                </div>
                <span class="cart-item__title">
                  <a href="${item.url}">
                    <span class="lead-sub">${item.product_title}</span>
                    <br />
                    ${variantTitleMarkup}
                    <br />
                    <span class="item__price lead-sub">${Shopify.formatMoney(item.price)}</span>
                  </a>
                </span>
                <span class="cart-item__controls">
                  ${quantityBoxMarkup}
                  <button class="remove-from-cart" data-variant="${item.id}">
                    <span class="visually-hidden">Remove this item from your cart</span>
                    <span class="cart-close"></span>
                  </button>
                </span>
              </div>`;
            });
          }

          $cart.find(".cart-items").html(html);
          $cart.find(".cart-pop__total span").text(Shopify.formatMoney(subtotal));
          if (typeof callback === "function") {
            callback();
          }
        });
      }

      return {
        update: updateCart,
        open: function () {
          openCart();
        },
      };
    })();

    /**********************************************************************
      END –
      Updates the AJAX cart
    ***********************************************************************/

    /**********************************************************************
     7. 
      The Shopify.formatMoney method extracted from option_selection.js for stand-alone purposes.
      Money format handler
    ***********************************************************************/
    var Shopify = Shopify || {};
    Shopify.money_format = "${{amount}}";
    Shopify.formatMoney = function (cents, format) {
      if (typeof cents == "string") {
        cents = cents.replace(".", "");
      }
      var value = "";
      var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
      var formatString = format || this.money_format;

      function defaultOption(opt, def) {
        return typeof opt == "undefined" ? def : opt;
      }

      function formatWithDelimiters(number, precision, thousands, decimal) {
        precision = defaultOption(precision, 2);
        thousands = defaultOption(thousands, ",");
        decimal = defaultOption(decimal, ".");

        if (isNaN(number) || number == null) {
          return 0;
        }

        number = (number / 100.0).toFixed(precision);

        var parts = number.split("."),
          dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + thousands),
          cents = parts[1] ? decimal + parts[1] : "";

        return dollars + cents;
      }

      switch (formatString.match(placeholderRegex)[1]) {
        case "amount":
          value = formatWithDelimiters(cents, 2);
          break;
        case "amount_no_decimals":
          value = formatWithDelimiters(cents, 0);
          break;
        case "amount_with_comma_separator":
          value = formatWithDelimiters(cents, 2, ".", ",");
          break;
        case "amount_no_decimals_with_comma_separator":
          value = formatWithDelimiters(cents, 0, ".", ",");
          break;
      }
      return formatString.replace(placeholderRegex, value);
    };
    /**********************************************************************
     END –
      Money format handler
    ***********************************************************************/

    /*****************************************************************
     Adding to cart for variants on PDP pages
    ******************************************************************/
    var productVariants = (function () {
      /*** copying in shopify format money ***/
      var Shopify = Shopify || {};
      Shopify.money_format = "${{amount}}";
      Shopify.formatMoney = function (cents, format) {
        if (typeof cents == "string") {
          cents = cents.replace(".", "");
        }
        var value = "";
        var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
        var formatString = format || this.money_format;

        function defaultOption(opt, def) {
          return typeof opt == "undefined" ? def : opt;
        }

        function formatWithDelimiters(number, precision, thousands, decimal) {
          precision = defaultOption(precision, 2);
          thousands = defaultOption(thousands, ",");
          decimal = defaultOption(decimal, ".");

          if (isNaN(number) || number == null) {
            return 0;
          }

          number = (number / 100.0).toFixed(precision);

          var parts = number.split("."),
            dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + thousands),
            cents = parts[1] ? decimal + parts[1] : "";

          return dollars + cents;
        }

        switch (formatString.match(placeholderRegex)[1]) {
          case "amount":
            value = formatWithDelimiters(cents, 2);
            break;
          case "amount_no_decimals":
            value = formatWithDelimiters(cents, 0);
            break;
          case "amount_with_comma_separator":
            value = formatWithDelimiters(cents, 2, ".", ",");
            break;
          case "amount_no_decimals_with_comma_separator":
            value = formatWithDelimiters(cents, 0, ".", ",");
            break;
        }
        return formatString.replace(placeholderRegex, value);
      };
      /*** END – copying in shopify format money ***/

      // Selecting the form that contains product details.
      var $forms = $(".product-form");

      function handleSelected(selectedVariant, $form) {
        //console.log(selectedVariant);
        //console.log($form);

        var id = selectedVariant.id.toString();
        var title = selectedVariant.title;
        var image = selectedVariant.featured_image.src;
        var price = Shopify.formatMoney(selectedVariant.price);
        var comparePrice = Shopify.formatMoney(selectedVariant.compare_at_price);

        // Locate the matching <option> element within the $form
        var $selectedOption = $form.find(`option[value="${id}"]`);

        // Check if the form has the "pdp-form" class
        if ($form.hasClass("pdp-form")) {
          $(".variant-color-name").text(title);
          $(".pdp-price").text(price);
          $(".pdp-compare-price").text(comparePrice);
          $(".variant-img-container, .variant-img-container-v2").children().removeClass("active");
          $(".variant-img-container, .variant-img-container-v2")
            .find("." + id)
            .addClass("active");

          /** Logic for showing or hiding 'LIMITED STOCK' **/
          if (selectedVariant.available) {
            // Check if the matching option exists
            if ($selectedOption.length) {
              // Get the stock level from the matching option's data attribute
              var stockLevel = parseInt($selectedOption.data("stocklevel") || 0, 10);

              // Validate stock level
              if (!isNaN(stockLevel) && stockLevel > 0) {
                // Target the element where you want to append the badge
                //var badgeContainer = $(".product-form__group--color .label.large");
                var badgeContainer = $(".lead.pdp-price");

                if (stockLevel < 12) {
                  // If stock level is less than 12, show the badge
                  if (!badgeContainer.find(".limited-badge").length) {
                    badgeContainer.append('<span class="limited-badge">LIMITED STOCK</span>');
                  }
                } else {
                  // Otherwise, remove the badge if it exists
                  badgeContainer.find(".limited-badge").remove();
                }
              } else {
                console.warn(`Invalid stock level: ${stockLevel} for variant ID: ${id}`);
                // Remove badge if stock level is invalid
                $(".product-form__group--color .label.large .limited-badge").remove();
              }
            } else {
              console.error(`Matching <option> not found for variant ID: ${id}`);
            }
          } else {
            // If the variant is unavailable, ensure the badge is removed
            $(".product-form__group--color .label.large .limited-badge").remove();
          }
          /** END – Logic for showing or hiding 'LIMITED STOCK' **/

          // Handle compare price visibility
          if (selectedVariant.compare_at_price == "$0" || selectedVariant.compare_at_price == null) {
            $(".pdp-compare-price").css("display", "none");
          } else {
            $(".pdp-compare-price").css("display", "inline-block");
          }

          // Check if the selected option is available for preorder
          if ($selectedOption.data("available-for-preorder")) {
            var mainMsg = $selectedOption.data("preorder-main-message");
            var subMsg = $selectedOption.data("preorder-sub-message");

            $(".preorder-message-main").text(mainMsg);
            $(".preorder-message-sub").text(subMsg);
            $(".preorder-wrap").addClass("show");
          } else {
            // Ensure preorder elements do not have the 'show' class if not available for preorder
            $(".preorder-wrap").removeClass("show");
          }
        } else {
          var $pcard = $form.closest(".product-card");
          $pcard.find(".variant-title").text(title);
          var $image = $pcard.find(".product-card__image img");
          $image.attr("src", image);

          // Handle addon cards specifically
          var $addonCard = $form.closest(".addon-card");
          if ($addonCard.length) {
            var $addonImage = $addonCard.find(".addon-card__img img");
            $addonImage.attr("src", image);
          }
        }
      }

      // Function to hide non-existent combinations of product variants.
      function hideNonExistent(variant, $form, nonExistentCombinations) {
        $.each(nonExistentCombinations, function (i, combo) {
          // Code to check if the combination exists or not.
          // If not, marks the options as 'unavailable'.
          var match1 = false;
          var match2 = false;
          var match3 = false;
          var message = combo.option1;
          if (combo.option1 == variant.option1) {
            match1 = true;
          }
          if (combo.option2 == null || combo.unavailable == "2" || combo.option2 == variant.option2) {
            match2 = true;
            if (combo.option2 != null && combo.unavailable != "2") {
              message += " + " + combo.option2;
            }
          }
          if (combo.option3 == null || combo.unavailable == "3" || combo.option3 == variant.option3) {
            match3 = true;
            if (combo.option3 != null && combo.unavailable != "3") {
              message += " + " + combo.option3;
            }
          }
          if (match1 && match2 && match3) {
            var $options = $form.find(".product-form__group__select option");
            var $buttons = $form.find('input[data-option-index="' + combo.unavailable + '"]');

            var unavailableSelector = "option" + combo.unavailable;

            $options.each(function () {
              var $option = $(this);
              if ($option.val() == combo[unavailableSelector] && !$option.hasClass("unavailable")) {
                $option.addClass("unavailable");
                $option.attr("disabled", true);
                $option.text($option.val() + " (Unavailable in  " + message + ")");
              }
            });

            $buttons.each(function () {
              var $option = $(this);
              if ($option.val() == combo[unavailableSelector] && !$option.hasClass("unavailable")) {
                $option.attr("disabled", true);
                $option.addClass("unavailable");
              }
            });
          }
        });
      }

      // Function to handle non-existent product combinations.
      function handleNonExistent(options, $form) {
        // Code to find the closest available variant and select it.

        var data = JSON.parse($form.find(".product-form__data").text());
        var variants = data.variants;

        var $groups = $form.find(".product-form__group");
        var $firstSelect = $groups.eq(0).find(".product-form__group__select select");

        var firstOption = $firstSelect.val();
        var replaceVariant = false;

        $.each(variants, function (i, variant) {
          if (variant.option1 == firstOption) {
            replaceVariant = variant;

            if (variant.available) {
              return false;
            }
          }
        });

        if (replaceVariant) {
          var index = 0;
          $groups.each(function () {
            index++;
            var optionSelector = "option" + index;
            $(this)
              .find('input[value="' + replaceVariant[optionSelector] + '"]')
              .trigger("click");
          });
        }
      }

      // Function to handle selection of product variant.
      function selectVariant($form, nonExistentCombinations) {
        // Code to handle selection of a variant.
        // It updates the main select value, replaces URL, enables/disables add to cart button,
        // and calls `hideNonExistent` to update the UI accordingly.
        var data = JSON.parse($form.find(".product-form__data").text());
        var variants = data.variants;
        var $atc = $form.find(".atc-btn");
        var atcText = $atc.data("text");
        var $groups = $form.find(".product-form__group");
        var $mainSelect = $form.find(".product-form__select select");

        var options = [];

        $groups.each(function () {
          var $this = $(this);
          var val = $this.find(".product-form__group__select select").val();
          options.push(val);
          $this.find(".selected-option").text(val);
        });

        var selectedVariant = false;

        $.each(variants, function (i, variant) {
          if (variant.option1 == options[0] && variant.option2 == options[1] && variant.option3 == options[2]) {
            selectedVariant = variant;
            return false;
          }
        });

        if (selectedVariant) {
          $mainSelect.val(selectedVariant.id);

          if (selectedVariant.available) {
            $atc.attr("disabled", false);
            $atc.text(atcText);
            $(".back-in-stock-wrap").removeClass("show");
            $(".featured-bundle-wrap").removeClass("hide");
            $(".featured-bundle-wrap").addClass("show");
          } else {
            $atc.attr("disabled", true);
            $atc.text("Sold Out");
            $(".featured-bundle-wrap").removeClass("show");
            $(".featured-bundle-wrap").addClass("hide");

            if (!$(".pdp-atc__actions").hasClass("external-active")) {
              $(".back-in-stock-wrap").addClass("show");
            }

            //console.log(selectedVariant);
            //$("#bis-productid").text(JSON.stringify(selectedVariant));
          }
          hideNonExistent(selectedVariant, $form, nonExistentCombinations);

          //do other theme specific things after a variant is selected
          //change image slide, update price etc...
          //selectedVariant is an object including all of its information that you may need
          handleSelected(selectedVariant, $form);

          if ($form.hasClass("pdp-form")) {
            // if this is a PDP change, change the URL to add variant to URL
            // we also check a variety of UTM terms inside of the URL and
            // ensure that they're kept
            var currentUrl = new URL(window.location.href);
            var params = new URLSearchParams(currentUrl.search);

            // Update the 'variant' parameter with the new value
            params.set("variant", selectedVariant.id);

            // Replace the current URL with the new one, preserving existing parameters
            currentUrl.search = params.toString();
            window.history.replaceState(null, null, currentUrl.toString());

            // Update the <title> with the new variant title, ensuring a space before "|"
            var currentTitle = document.title;
            var newTitle = currentTitle.replace(/^[^|]+/, selectedVariant.title + " ");
            document.title = newTitle;
          }
        } else {
          //no mathing variant was found edge case - add descriptive text to atc button and maybe output a message?
          handleNonExistent(options, $form);
        }
      }

      // Function to find and store non-existent combinations of product variants.
      function findNonExistent($form) {
        var $groups = $form.find(".product-form__group");
        var $mainSelect = $form.find(".product-form__select select");
        var nonExistentCombinations = [];

        // Code to find non-existent combinations and add them to `nonExistentCombinations`.
        // It works by examining every combination of available options.
        if (!$groups.length || $groups.length == 1) {
          return;
        }

        function AddUniqueComobo(combo) {
          var alreadyExists = false;
          // there is some "duplication" happening here, need to figure out the best way to prevent it
          //the code below seemed to work, but noticed its removing more than I want
          // $.each(nonExistentCombinations,function(i,ecombo){
          // 	if( ecombo.unavailable == combo.unavailable && ecombo.option1 == combo.option1 ){
          // 		alreadyExists = true;
          // 	}
          // });
          if (!alreadyExists) {
            nonExistentCombinations.push(combo);
          }
        }

        $groups
          .eq(0)
          .find(".product-form__group__select option")
          .each(function () {
            var $first = $(this);
            $groups
              .eq(1)
              .find(".product-form__group__select option")
              .each(function () {
                var $second = $(this);
                var combo = {
                  option1: null,
                  option2: null,
                  option3: null,
                  unavailable: null,
                };
                if (
                  !$mainSelect.find('option[data-option1="' + $first.val() + '"][data-option2="' + $second.val() + '"]').length
                ) {
                  combo.option1 = $first.val();
                  combo.option2 = $second.val();
                  combo.unavailable = "2";
                  nonExistentCombinations.push(combo);
                }
              });
            $groups
              .eq(2)
              .find(".product-form__group__select option")
              .each(function () {
                var $third = $(this);
                var combo = {
                  option1: null,
                  option2: null,
                  option3: null,
                  unavailable: null,
                };
                if (
                  !$mainSelect.find('option[data-option1="' + $first.val() + '"][data-option3="' + $third.val() + '"]').length
                ) {
                  combo.option1 = $first.val();
                  combo.option3 = $third.val();
                  combo.unavailable = "3";
                  nonExistentCombinations.push(combo);
                }
              });
          });

        $groups
          .eq(0)
          .find(".product-form__group__select option")
          .each(function () {
            var $first = $(this);
            $groups
              .eq(1)
              .find(".product-form__group__select option")
              .each(function () {
                var $second = $(this);
                $groups
                  .eq(2)
                  .find(".product-form__group__select option")
                  .each(function () {
                    var $third = $(this);
                    var combo = {
                      option1: null,
                      option2: null,
                      option3: null,
                      unavailable: null,
                    };
                    if (
                      !$mainSelect.find(
                        'option[data-option1="' +
                          $first.val() +
                          '"][data-option2="' +
                          $second.val() +
                          '"][data-option3="' +
                          $third.val() +
                          '"]'
                      ).length
                    ) {
                      combo.option1 = $first.val();
                      combo.option2 = $second.val();
                      combo.option3 = $third.val();
                      combo.unavailable = "3";
                      AddUniqueComobo(combo);
                    }
                  });
              });
            $groups
              .eq(2)
              .find(".product-form__group__select option")
              .each(function () {
                var $third = $(this);
                $groups
                  .eq(1)
                  .find(".product-form__group__select option")
                  .each(function () {
                    var $second = $(this);
                    var combo = {
                      option1: null,
                      option2: null,
                      option3: null,
                      unavailable: null,
                    };
                    if (
                      !$mainSelect.find(
                        'option[data-option1="' +
                          $first.val() +
                          '"][data-option2="' +
                          $second.val() +
                          '"][data-option3="' +
                          $third.val() +
                          '"]'
                      ).length
                    ) {
                      combo.option1 = $first.val();
                      combo.option2 = $second.val();
                      combo.option3 = $third.val();
                      combo.unavailable = "2";
                      AddUniqueComobo(combo);
                    }
                  });
              });
          });

        return nonExistentCombinations;
      }

      // Shopify related logic.
      var Shopify = Shopify || {};
      // Required functionality from deprecated options_selection.js.
      // Code to define utility functions used later in Shopify logic.

      // Required functionality from depricated options_selection.js
      (Shopify.arrayIncludes = function (e, t) {
        // Code to update the available options in a selector based on selected values of other selectors.
        for (var n = 0; n < e.length; n++) if (e[n] == t) return !0;
        return !1;
      }),
        (Shopify.uniq = function (e) {
          for (var t = [], n = 0; n < e.length; n++) Shopify.arrayIncludes(t, e[n]) || t.push(e[n]);
          return t;
        });

      // Shopify logic for linking option selectors.
      function updateOptionsInSelector(selectorIndex, $form, optionsMap) {
        // Code to update the available options in a selector based on selected values of other selectors.
        switch (selectorIndex) {
          case 0:
            var key = "root";
            var $selector = $form.find(".product-form__group__select:eq(0) select");
            break;
          case 1:
            var key = $form.find(".product-form__group__select:eq(0) select").val();
            var $selector = $form.find(".product-form__group__select:eq(1) select");
            break;
          case 2:
            var key = $form.find(".product-form__group__select:eq(0) select").val();
            key += " / " + $form.find(".product-form__group__select:eq(1) select").val();
            var $selector = $form.find(".product-form__group__select:eq(2) select");
        }

        var availableOptions = optionsMap[key];

        $selector.find("option").each(function (i, option) {
          var $this = $(this);
          var value = $this.val();
          var $radio = $this.closest(".product-form__group").find('input[type="radio"][value="' + value + '"]');

          $this.removeClass("unavailable");
          $this.attr("disabled", false);
          $radio.removeClass("unavailable");
          $radio.attr("disabled", false);

          if (availableOptions && availableOptions.includes(value)) {
            $this.text($this.val());
            $this.removeClass("oos");
            $radio.removeClass("oos");
          } else {
            $this.text($this.val() + " (Soldout)");
            $this.addClass("oos");
            $radio.addClass("oos");

            // if we want to link to an external URL do this
            //console.log($radio.data("external-url"));
            if ($radio.data("external-url") !== undefined) {
              $this.removeClass("oos");
              $radio.removeClass("oos");
            }
          }
        });
      }

      // Shopify logic for linking option selectors.
      function linkOptionSelectors(product, $form) {
        var optionsMap = {};
        // Code to build mapping between product options and variants.

        // Building our mapping object.
        for (var i = 0; i < product.variants.length; i++) {
          var variant = product.variants[i];
          if (variant.available) {
            // Gathering values for the 1st drop-down.
            optionsMap["root"] = optionsMap["root"] || [];
            optionsMap["root"].push(variant.option1);
            optionsMap["root"] = Shopify.uniq(optionsMap["root"]);
            // Gathering values for the 2nd drop-down.
            if (product.options.includes("Color")) {
              var key = variant.option1;
              optionsMap[key] = optionsMap[key] || [];
              optionsMap[key].push(variant.option2);
              optionsMap[key] = Shopify.uniq(optionsMap[key]);
            }
            // Gathering values for the 3rd drop-down.
            if (product.options.length === 3) {
              var key = variant.option1 + " / " + variant.option2;
              optionsMap[key] = optionsMap[key] || [];
              optionsMap[key].push(variant.option3);
              optionsMap[key] = Shopify.uniq(optionsMap[key]);
            }
          }
        }

        // Update options right away.
        updateOptionsInSelector(0, $form, optionsMap);

        //if (product.options.length > 1) updateOptionsInSelector(1, $form, optionsMap);
        if (product.options.includes("Color")) updateOptionsInSelector(1, $form, optionsMap);

        if (product.options.length === 3) updateOptionsInSelector(2, $form, optionsMap);

        // When there is an update in the first dropdown.
        $form.find(".product-form__group__select:eq(0) select").change(function () {
          updateOptionsInSelector(1, $form, optionsMap);
          if (product.options.length === 3) updateOptionsInSelector(2, $form, optionsMap);
          return true;
        });

        // When there is an update in the second dropdown.
        $form.find(".product-form__group__select:eq(1) select").change(function () {
          if (product.options.length === 3) updateOptionsInSelector(2, $form, optionsMap);
          return true;
        });
      }

      $forms.on("change", "select", function () {
        var $form = $(this).closest("form");
        var data = JSON.parse($form.find(".product-form__data").text());
        var nonExistentCombinations = findNonExistent($form);

        linkOptionSelectors(data, $form);
        selectVariant($form, nonExistentCombinations);
      });

      $forms.each(function () {
        var $form = $(this);
        var $groups = $form.find(".product-form__group");
        var $firstSelect = $groups.eq(0).find(".product-form__group__select select");

        // Event handler for changing product options via radio buttons.
        $form.find(".product-form__group__buttons input").change(function () {
          // Code to synchronize radio button with corresponding select element.
          var $this = $(this);
          var val = $this.val();

          $this.closest(".product-form__group").find(".product-form__group__select select").val(val).trigger("change");

          if ($this.attr("data-external-url") !== undefined) {
            $(".external-link-btn").attr("href", $this.attr("data-external-url"));
            $(".external-link-btn").text($this.attr("data-external-url-text"));
            $(".pdp-atc__actions").addClass("external-active");

            $(".back-in-stock-wrap").removeClass("show");
          } else {
            $(".pdp-atc__actions").removeClass("external-active");
          }
        });

        $firstSelect.trigger("change");
      });
    })();
    /*****************************************************************
     END – Adding to cart for variants on PDP pages
    ******************************************************************/
  }); // end .ready()
})(jQuery);
